<div style="height: 17pc; display: flex; align-items: center; justify-content: center; flex-direction: column;">
    <div class="not-found">
      <img src="../../assets/images/notfound1.jpg" alt="Not Found" class="not-found-image" />
      <h3>Inventory Not Available</h3>
      <a routerLink="/" (click)="refresh()">Try Another Project</a>
    </div>
  </div>
  